var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.paymentStatus)?_c('h2',{staticClass:"stripe-payment-success"},[_vm._v(_vm._s(_vm.message))]):_c('h2',{staticClass:"stripe-payment-error"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }